export default __webpack_public_path__ + "static/media/target.53ae9f04.jpeg";